
<div class="annunciator-container">

  <!-- NEW: MFM Toggle Button -->
  <button class="mfm-toggle-btn" (click)="toggleMFMView()">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z" />
    </svg>
    {{ showMFMView ? 'Show Annunciator' : 'Show MFM Data' }}
  </button>

  <!-- Existing Annunciator View -->
  <div class="machines-grid" *ngIf="isData && !showMFMView; else elseTemplate">
    <div *ngFor="let machine of machines | keyvalue; trackBy: trackByMachine" class="machine-card scrollable-card">
      <div class="machine-header">
        <span class="machine-title">Device ID {{ getMachineDisplayName(machine.key) }}</span>
        <span class="machine-status-indicator"></span>
      </div>

      <div class="machine-divider"></div>

      <div class="windows-grid">
        <div *ngFor="let windowKey of machine.value.order; trackBy: trackByWindow" class="window-item">
          <div class="window-status" [class.active]="machine.value.data[windowKey] != 0">
            <span class="window-name" (click)="startEditing(machine.key, windowKey)">
              {{ windowKey }}
            </span>

            <input *ngIf="editingWindow.machineId === machine.key && editingWindow.key === windowKey" type="text"
              [value]="windowKey" (blur)="updateWindowName(machine.key, windowKey, $any($event.target).value)"
              (keyup.enter)="updateWindowName(machine.key, windowKey, $any($event.target).value)"
              class="window-name-edit" autofocus>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- NEW: MFM Data View -->
  <div class="mfm-view-container" *ngIf="showMFMView">

    <!-- MFM Grid (when no MFM selected) -->
    <div class="mfm-grid" *ngIf="!selectedMFM">
      <div *ngFor="let topic of mfmTopics" class="mfm-card" (click)="selectMFM(topic.split('/')[1])">
        <div class="mfm-card-header">
          <h3>{{ getMFMName(topic.split('/')[1]) }}</h3>
          <span class="mfm-status-badge" [class.active]="mfmData[topic.split('/')[1]]">
            {{ getMFMStatus(topic.split('/')[1]) }}
          </span>
        </div>
        <div class="mfm-card-body">
          <div class="mfm-preview" *ngIf="mfmData[topic.split('/')[1]]">
            <div class="mfm-preview-item">
              <span class="label">Name:</span>
              <span class="value">{{ topic }}</span>
            </div>
            <div class="mfm-preview-item">
              <span class="label">Last Update:</span>
              <span class="value">{{ mfmData[topic.split('/')[1]].timestamp || 'N/A' }}</span>
            </div>
          </div>
          <div class="mfm-no-data" *ngIf="!mfmData[topic.split('/')[1]]">
            <p>No data received yet</p>
          </div>
        </div>
        <div class="mfm-card-footer">
          <span class="view-details">Click to view details →</span>
        </div>
      </div>
    </div>

    <!-- MFM Details View (when MFM selected) -->
    <div class="mfm-details-container" *ngIf="selectedMFM">
      <div class="mfm-details-header">
        <button class="back-btn" (click)="closeMFMDetails()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Back
        </button>
        <h2>{{ getMFMName(selectedMFM!) }} - Detailed Data</h2>
        <span class="mfm-timestamp">{{ mfmData[selectedMFM]?.timestamp || 'N/A' }}</span>
      </div>

      <div class="mfm-table-wrapper" *ngIf="mfmData[selectedMFM]">
        <table class="mfm-data-table">
          <thead>
            <tr>
              <th>Parameter</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let key of getObjectKeys(mfmData[selectedMFM].data)">
              <td class="param-name">{{ key }}</td>
              <td class="param-value">{{ formatValue(mfmData[selectedMFM].data[key]) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mfm-no-data-message" *ngIf="!mfmData[selectedMFM]">
        <p>No data available for MFM {{ selectedMFM }}</p>
      </div>
    </div>
  </div>

  <ng-template #elseTemplate>
    <div class="no-data-message" *ngIf="!showMFMView">
      No Data found
    </div>
  </ng-template>
</div>